import { Form, Radio } from 'antd';
import { useContext } from 'react';

import { CurrencyContext } from 'app/components/commons/Currency/CurrencyContext/CurrencyContext';
import { FormLineLayout } from 'app/components/commons/Form/FormLineLayout/FormLineLayout';
import { SwitchableInput } from 'app/components/commons/SwitchableInput/SwitchableInput';
import { ViewEditModeContext } from 'app/context/ViewEditModeContext/ViewEditModeContext';

export const RoomService = () => {
  const { currencyInput, currencyFormatter } = useContext(CurrencyContext);
  const { isViewMode, isEditMode } = useContext(ViewEditModeContext);

  const form = Form.useFormInstance();
  const roomServiceIncluded = Form.useWatch('roomServiceIncluded', form);
  const roomServiceAvailable = Form.useWatch('roomServiceAvailable', form);
  const roomServicePrice = Form.useWatch('roomServicePrice', form);

  return (
    <FormLineLayout label="Room service" labelOnTop>
      <Form.Item name="roomServiceAvailable">
        <SwitchableInput
          value={roomServiceIncluded}
          noBackground
          noBorder
          disabled={isViewMode}
          childNode={
            roomServiceAvailable ? (
              <div>
                <Form.Item name="roomServiceIncluded">
                  <Radio.Group disabled={isViewMode}>
                    <Radio value={true}>Free of charge</Radio>
                    <Radio value={false}>Applicable fees</Radio>
                  </Radio.Group>
                </Form.Item>
                {!roomServiceIncluded && (
                  <Form.Item name="roomServicePrice">
                    {isEditMode
                      ? currencyInput({ min: 0 })
                      : currencyFormatter(roomServicePrice)}
                  </Form.Item>
                )}
              </div>
            ) : (
              <></>
            )
          }
        />
      </Form.Item>
    </FormLineLayout>
  );
};
